
import { useState, useRef, useEffect, Fragment } from 'react';

import { Canvas, useFrame, useLoader } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";

import * as THREE from "three";



function LoginAnim(props)
{
    const [status, setStatus] = useState(0);
 
 
  
    function Box() {



            const texture = useLoader(THREE.TextureLoader, "/../../logo.png");
            const texture2 = useLoader(THREE.TextureLoader, "/../../elizak.png");
            const texture3 = useLoader(THREE.TextureLoader, "/../../info800.png");


            const meshRef = useRef();
            const meshRef1 = useRef();
            const meshRef2 = useRef();
            const meshRef3 = useRef();
            const meshRef4 = useRef();
            const meshRef5 = useRef();
            const meshRef6 = useRef();
            const meshRef7 = useRef();

            const groupRef = useRef();

            useFrame(() => {
                meshRef.current.rotation.x += 0.005;
                meshRef.current.rotation.y += 0.005;

                meshRef1.current.rotation.x += 0.003;
                meshRef1.current.rotation.y -= 0.003;

                meshRef2.current.rotation.x -= 0.002;
                meshRef2.current.rotation.y += 0.007;

                meshRef3.current.rotation.x -= 0.003;
                meshRef3.current.rotation.y -= 0.003;

                meshRef4.current.rotation.x += 0.003;
                meshRef4.current.rotation.y -= 0.003;

                groupRef.current.rotation.x += 0.001;
                groupRef.current.rotation.y -= 0.005;
            });

            return (
                <group ref={groupRef} >
                    <mesh ref={meshRef} position={[0,-1.5,0]}>
                        <boxGeometry args={[1, 1, 1]} />
                        <meshStandardMaterial  color="#1C313E"  transparent={true} opacity={0.4} />
                    </mesh>

                    <mesh ref={meshRef1} position={[-3,3.5,-2]}>
                        <boxGeometry args={[1, 1, 1]} />
                        <meshStandardMaterial   attach="material-0" map={texture} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial    attach="material-1" map={texture} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial   attach="material-2" map={texture} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial   attach="material-3" map={texture} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial   attach="material-4" map={texture} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial  attach="material-5" map={texture} transparent={true} opacity={0.4} />                        
                    </mesh>

                     <mesh ref={meshRef2} position={[0,3.5,2]}>
                        <boxGeometry args={[1, 1, 1]} />
                         <meshStandardMaterial   attach="material-0" map={texture3} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial    attach="material-1" map={texture3} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial   attach="material-2" map={texture3} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial   attach="material-3" map={texture3} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial   attach="material-4" map={texture3} transparent={true} opacity={0.4} />                        
                        <meshStandardMaterial  attach="material-5" map={texture3} transparent={true} opacity={0.4} />     
                    </mesh>

                    <mesh ref={meshRef3} position={[-2,-3.5,2]}>
                        <boxGeometry args={[1, 1, 1]} />
                         <meshStandardMaterial   attach="material-0" map={texture2} transparent={true} opacity={0.5} />                        
                        <meshStandardMaterial    attach="material-1" map={texture2} transparent={true} opacity={0.5} />                        
                        <meshStandardMaterial   attach="material-2" map={texture2} transparent={true} opacity={0.5} />                        
                        <meshStandardMaterial   attach="material-3" map={texture2} transparent={true} opacity={0.5} />                        
                        <meshStandardMaterial   attach="material-4" map={texture2} transparent={true} opacity={0.5} />                        
                        <meshStandardMaterial   attach="material-5" map={texture2} transparent={true} opacity={0.5} />    
                    </mesh>

                    <mesh ref={meshRef4} position={[-1,-3.5,-3.5]}>
                        <boxGeometry args={[1, 1, 1]} />
                        <meshStandardMaterial  color="#859486"  transparent={true} opacity={0.4} />
                    </mesh>

                    <mesh ref={meshRef5} position={[-4,-2.5,0]}>
                        <boxGeometry args={[1, 1, 1]} />
                        <meshStandardMaterial  color="#4a4f64"  transparent={true} opacity={0.4} />
                    </mesh>

                    <mesh ref={meshRef6} position={[1,3.5,2]}>
                        <boxGeometry args={[2, 2, 2]} />
                        <meshStandardMaterial  color="#4a4f64"  transparent={true} opacity={0.4} />
                    </mesh>

                    <mesh ref={meshRef7} position={[-5,-3.5,5]}>
                        <boxGeometry args={[3, 3, 3]} />
                        <meshStandardMaterial  color="#4a4f64"  transparent={true} opacity={0.4} />
                    </mesh>

                </group>                
            );
            }
 


    function OrbitingSphere(props) {

            const meshRef = useRef();
            var radius = 1;
            var exTime = 0;

            if(props.radius != undefined)  radius = props.radius;
            if(props.exTime != undefined)  exTime = props.exTime;

            useFrame(({ clock }) => {
                const t = clock.getElapsedTime();        
                meshRef.current.position.x = Math.cos(t + exTime) * radius;
                meshRef.current.position.z = Math.sin(t + exTime) * radius;
            });

            return (
                <mesh ref={meshRef}>
                <sphereGeometry args={[1, 32, 32]} />
                <meshStandardMaterial color="#122a49" transparent={true} opacity={0.3} />
                </mesh>
            );
     }


    function SphereX ()
    {
        const groupRef = useRef();
        const groupRef2 = useRef();


 

      useFrame(({ clock }) => {

                groupRef.current.rotation.x += 0.000071;
           //     groupRef.current.rotation.y -= 0.000001;

             //   groupRef2.current.rotation.x -= 0.000502;
                groupRef2.current.rotation.y += 0.000001;


                const t = clock.getElapsedTime();        
                const s = 1 + Math.sin(t) * 1.1;
                groupRef.current.scale.set(s, 1, s);

                groupRef2.current.scale.set(s, 1, s);
            
            });



          return (
               <Fragment>
                    <group ref={groupRef} >
                        <OrbitingSphere radius={0.5} exTime={0}/>
                        <OrbitingSphere radius={1.5} exTime={1.5}/>                                                          
                        <OrbitingSphere radius={2.0} exTime={4.5}/>                                   
                </group>
                 <group ref={groupRef2} >
                        <OrbitingSphere radius={0.5} exTime={2}/>                                                                       
                        <OrbitingSphere radius={0.5} exTime={4.0}/> 
 
                 </group>
               </Fragment>             
          )  
    }





    if(status == 0)
    {
        setStatus(1);        
    }

  

    return   <Canvas style={{ position:'absolute', left:0, right:0,top:0, bottom:0,   }}>
                    <ambientLight intensity={0.9} />
                    <pointLight position={[10,10, 10]} />        
        
                    <SphereX/>
             
                 
                    <OrbitControls />
    </Canvas> 
}


export default LoginAnim;